<template>
	<div id="shoppingCar">
		<div class="header">
			进货单
			<a href="javascript:;">编辑</a>
		</div>

		<div class="c-item flex-item gys-tit">
			<div class="radio-wrap">
				<span :class="{'border':shopcartData.is_all_check == 'N'}"><img v-show="shopcartData.is_all_check == 'Y'" src="@/common/images/icon-radio.png" alt=""></span>
				<span v-show="editMode"></span>
			</div>
			<p>{{shopcartData.gys_name}}</p>
		</div>

		<!-- 主商品列表 -->
		<ul class="main-goods">
			<li class="c-item flex-item main-goods-item" v-for="item in shopcartData.shopcart_goods_list">
				<div class="radio-wrap" @click="checkItem(item.id)">
					<span :class="{'border':item.checkStatus == 'UNCHECK'}"><img v-show="item.checkStatus == 'CHECK'" src="@/common/images/icon-radio.png" alt=""></span>
					<span v-show="editMode"></span>
				</div>
				<img :src="item.photo_url||'../../static/404.png'" alt="">
				<div class="text-detail">
					<p class="goods_name line-clamp2">{{item.goods_name}}</p>
					<p class="stock_count">可销售：{{item.showStockCountType}}</p>
					<p class="sales_price">￥{{item.sales_price|formatMoney}}/{{item.specific_name}}</p>
					<div class="add-mod flex-item">
						<span class="btn-minus"></span>
						<span class="qit">1</span>
						<span class="btn-plus"></span>
					</div>
				</div>
			</li>
		</ul>

		<!-- 底部结算 -->
		<div class="wrap-settle flex-item">
			<div class="radio-wrap">
				<span :class="{'border':shopcartData.is_all_check == 'N'}"><img v-show="shopcartData.is_all_check == 'Y'" src="@/common/images/icon-radio.png" alt=""></span>
				<span v-show="editMode"></span>
				全选
			</div>
			<div class="amount">
				<div class="pay_amount">应付款：￥{{shopcartData.pay_amount|formatMoney}}</div>
				<div class="sum_goods_amount">合计：￥{{shopcartData.sum_goods_amount|formatMoney}} 优惠：￥{{shopcartData.discount_amount|formatMoney}}</div>
			</div>
			<div class="settle">
				<a href="javascript:;">结算</a>
				<!-- <a href="javascript:;">删除</a> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				editMode:false,
				shopcartData:{}
			}
		},
		filters:{
      formatMoney(val) {
        if(!isNaN(val)) {
          return val.toFixed(2);
        }
      }
    },
		mounted() {
			this.getShopCartList();
		},
		methods:{
			getShopCartList() {  //获取购物车在数据
        this.api.queryShopCartList({}).then(res=> {
          if(res.callStatus == 'SUCCESS') {
            this.shopcartData = res.data
          }
        })
      },
     	checkItem() {

     	}
		}
	}
</script>

<style scoped>
	#shoppingCar {
		height: 100%;
		padding-top: 88px;
		padding-bottom: 200px;
		overflow: auto;
		-webkit-overflow-scrolling: touch;
	}
	.header {
		position: absolute;
		top: 0;
    width: 100%;
    height: 88px;
    line-height: 88px;
    background: linear-gradient(to left, #1e90ff, #4fe4fa);
    text-align: center;
    font-size: 34px;
    color: #fff;
    z-index: 10;
	}
	.header a {
		position: absolute;
		right: 24px;
		color: #fff;
		font-size: 30px;
	}
	.gys-tit {
		margin-bottom: 20px;
		padding: 20px 24px;
		background: #FFF;
	}
	.gys-tit p {
		width: 637px;
		font-size: 30px;
	}
	.radio-wrap span {
		display: inline-block;
		width: 34px;
		height: 34px;
		border-radius: 50%;
		vertical-align: middle;
	}
	.radio-wrap .border {
		border: 0.5px solid #C7C7C7;
	}
	.radio-wrap span img {
		width: 34px;
		height: 34px;
		vertical-align: middle;
	}
	.main-goods-item {
		border-bottom: 0.5px solid #eee;
	}
	.main-goods-item>img {
		width: 175px;
		height: 175px;
	}
	.main-goods-item .text-detail {
		position: relative;
		width: 444px;
	}
	.stock_count {
		margin-top: 12px;
		color: #1e90ff;
		font-size: 26px;
	}
	.sales_price {
		margin-top: 50px;
		color: #FF6754;
	}

	.add-mod {
		position: absolute;
		bottom: 0;
		right: 0;
		border: 0.5px solid #CCCCCC;
	}
	.add-mod {
		border-radius: 8px;
	}
	.add-mod span {
		height: 46px;
		line-height: 46px;
	}
	.add-mod .btn-plus,.add-mod .btn-minus {
		width: 50px;
		background-size: 26px;
		background-repeat: no-repeat;
		background-position: center center;
	}
	.add-mod .btn-plus {
		background-image: url(../../../common/images/icon-add.png);
	}
	.add-mod .btn-minus {
		background-image: url(../../../common/images/icon-minus.png);
	}
	.add-mod .qit {
		width: 100px;
		border-left:0.5px solid #CCCCCC;
		border-right:0.5px solid #CCCCCC;
		text-align: center;
		font-size: 30px;
	}

	.wrap-settle {
		position: absolute;
		padding-left: 24px;
		bottom: 97px;
		width: 100%;
		height: 96px;
		background: #fff;
		z-index: 10;
		border-bottom: 0.5px solid #eee;
		border-top: 0.5px solid #eee;
	}
	.wrap-settle .amount {
		width: 386px;
		text-align: right;
	}
	.wrap-settle .pay_amount {
		font-size: 24px;
		color: #FF6754;
	}
	.wrap-settle .sum_goods_amount {
		color: #666666;
		font-size: 20px;
	}
	.settle a {
		display: block;
		height: 96px;
		line-height: 96px;
		width: 198px;
		background: linear-gradient(to left, #1e90ff, #4fe4fa);
		color: #fff;
		text-align: center;
		font-size: 30px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/shop/shoppingCar/shoppingCar.vue